import React from 'react';
import type Element from 'react';

type Props = {
  onChange: () => {},
  value: string,
  options: Array<Element>,
  id?: string,
  defaultValue?: string,
  modifier?: string
};

const Select = ({
  onChange,
  value,
  options,
  id = '',
  defaultValue = '',
  modifier = ''
}: Props) => (
  <div className={`c-select ${modifier && `c-select${modifier}`}`}>
    <select id={id} onChange={e => onChange(e.target.value)} value={value}>
      {defaultValue && (
        <option key={defaultValue} value="">
          {defaultValue}
        </option>
      )}
      {options.map(({ value: optionValue, label }) => (
        <option key={optionValue} value={optionValue}>
          {label}
        </option>
      ))}
    </select>
  </div>
);

export default Select;
